// dependency-graph-ignore-file
import { token } from '@atlaskit/tokens';

import {
  SELECTIONS_CONTAINER_ELEMENT_ID,
  SELECTIONS_FOCUS_CARAT_ELEMENT_ID,
} from '../constants';

function createElementById(id: string): HTMLDivElement {
  const el = document.createElement('div');

  el.id = id;

  return el;
}

/**
 * Creates the focus caret — the blue border that highlights the currently
 * focused cell. Starts hidden, positioned via transform by the effect.
 *
 * pointer-events: none so clicks pass through to the actual cell.
 */
export function createFocusCaretElement() {
  const focusCaret = createElementById(SELECTIONS_FOCUS_CARAT_ELEMENT_ID);

  focusCaret.style.position = 'absolute';
  focusCaret.style.display = 'none';
  focusCaret.style.boxSizing = 'border-box';
  focusCaret.style.border = `2px solid ${token('color.border.selected', '#0C66E4')}`;
  focusCaret.style.borderRadius = token('radius.small', '3px');
  focusCaret.style.pointerEvents = 'none';

  return focusCaret;
}

/**
 * Creates the container that holds all selection overlays (focus caret,
 * range highlights, etc.). Lives inside the scrollableContainer so it
 * scrolls with the grid content.
 *
 * pointer-events: none so the overlay doesn't block interactions with cells.
 */
export function createHighlightsContainerElement() {
  const overlayContainer = createElementById(SELECTIONS_CONTAINER_ELEMENT_ID);

  overlayContainer.style.position = 'absolute';
  overlayContainer.style.top = '0';
  overlayContainer.style.left = '0';
  overlayContainer.style.pointerEvents = 'none';
  overlayContainer.style.zIndex = '10';

  return overlayContainer;
}
